import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMobizHttpService, SerializableObjectList } from '../../common-react/core';
import { Inject, Injectable, InjectionToken } from '../../common-react/injection';

import { Location } from '../data/location.do';
import { PosturinnApiEndpointConfiguration } from '../other/api-endpoint-configuration.interface';
import { LocationType } from '../other/location-type.enum';
import { PosturinnServerApi } from '../other/posturinn-server-api.enum';

export interface ILocationsQueryParameters {
  locationType?: LocationType;
  term?: string;
  locationCode?: string;
  /** @deprecated the ILocationsQueryParameters.pageSize parameter is not used. */
  pageSize?: number;
}

export interface ILocationService {
  getLocations(queryParameters?: ILocationsQueryParameters): Observable<Location[]>;
  getLocationByCode(locationCode: string): Observable<Location[]>;
}

export const ILocationService: InjectionToken<ILocationService>
  = new InjectionToken<ILocationService>('ILocationService');

@Injectable()
export class LocationService implements ILocationService {
  constructor(
    @Inject(IMobizHttpService)
    private httpService: IMobizHttpService,
  ) {
  }

  public getLocations(queryParameters?: ILocationsQueryParameters): Observable<Location[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.Locations,
      queryParameters: {
        ...queryParameters,
      },
    };
    const list: SerializableObjectList<Location> = new SerializableObjectList(Location);
    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<Location>): Location[] => {
        return response.items ? response.items : [];
      })
    );
  }

  public getLocationByCode(locationCode: string): Observable<Location[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.Locations,
      queryParameters: {
        locationCode: locationCode
      },
    };
    const list: SerializableObjectList<Location> = new SerializableObjectList(Location);
    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<Location>): Location[] => response.items)
    );
  }

}
